import { useEffect, useRef } from 'react';

/** Let tall panels scroll into view before pinning their bottom edge. */
export const useStickyPanel = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const panel = ref.current;
        if (!panel) return undefined;

        const updateHeight = () => {
            panel.style.setProperty('--sticky-panel-height', `${panel.offsetHeight}px`);
        };
        updateHeight();
        const observer = new ResizeObserver(updateHeight);
        observer.observe(panel);
        return () => observer.disconnect();
    }, []);

    return ref;
};
